import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove, getSource } from 'src/services/StockAdjustments';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Select, { components } from 'react-select';
import Moment from 'moment';
import { getAll } from 'src/services/Products';
function StockAdjustmentActions() {
  let today = new Date();
  let todayMonth = today.getMonth() + 1;
  let todayYear = today.getFullYear();
  let todayDate = today.getDate();
  let showToday = todayYear + '-' + todayMonth + '-' + todayDate;
  const d = new Date();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var date = ('0' + d.getDate()).slice(-2);
  var datestringNow = d.getFullYear() + '-' + month + '-' + date;
  const [id, setID] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [sku, setSKU] = useState('');
  const [name, setName] = useState('');
  const [rqb, setRQB] = useState(0);
  const [rqa, setRQA] = useState(0);
  const [yqb, setYQB] = useState(0);
  const [yqa, setYQA] = useState(0);
  const [adjDate, setAdjDate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [diffRoll, setDiffRoll] = useState(0);
  const [diffYards, setDiffYards] = useState(0);
  const [notes, setNotes] = useState('');
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setSKU(location?.state?.sku ?? '');
      setName(location?.state?.name ?? '');

      setSelectedProduct({
        id: location.state.productID,
        label: location.state.productName,
        value: location.state.productID
      });
    }
    fetchProducts();
  }, [location]);
  useEffect(() => {
    setDiffRoll(rqa - rqb);
    setDiffYards(yqa - yqb);
  }, [rqa, yqa, selectedProduct]);
  const fetchProducts = async () => {
    let response = await getSource();

    if (response.success === 1) {
      let data =
        response?.data.map((item) => {
          return {
            id: item.id,
            label: `${item.name} ${item.sku ? '- ' + item.sku : ''}`,
            value: item.id,
            sku: item.sku,
            rqb: item.stock_pcs,
            yqb: item.stock_yards
          };
        }) ?? [];

      setProductOptions(data);
    }
  };
  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor('red');
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        productID: selectedProduct.value,
        notes: notes,
        rqa: rqa,
        rqb: rqb,
        yqa: yqa,
        yqb: yqb,
        adjDate: adjDate
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor('red');
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get('errorMessage'));
            setOpen(true);
            setColor('red');
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }

  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CCardHeader>Actions - Produk</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tanggal Adjustment</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="date"
                value={adjDate}
                max={Moment(showToday).format('YYYY-MM-DD')}
                onChange={(e) => setAdjDate(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Product</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Produk"
                value={selectedProduct}
                options={productOptions}
                onChange={(e) => {
                  setSelectedProduct(e);
                  setRQB(e.rqb);
                  setYQB(e.yqb);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Stock Sistem (Roll/PCS)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={rqb}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setRQB(e.target.value)}
                feedbackInvalid="Required value"
                disabled
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Stock Sekarang (Roll/PCS)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={rqa}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setRQA(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Stock Sistem (Yard)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={yqb}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setYQB(e.target.value)}
                feedbackInvalid="Required value"
                disabled
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Stock Sekarang (Yard)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={yqa}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setYQA(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Selisih (Roll/PCS)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput type="number" value={diffRoll} onWheel={(e) => e.target.blur()} disabled />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Selisih (Yard)</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput type="number" value={diffYards} onWheel={(e) => e.target.blur()} disabled />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Notes</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
        </div>
        {/* const [diffRoll, setDiffRoll] = useState(0); const [diffYards, setDiffYards] = useState(0); */}
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white'
            }}
            type="submit"
          >
            Save
          </CButton>
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default StockAdjustmentActions;
